import { DateInputProps } from '../input';
import * as React from 'react';
import moment from 'moment';
import DateInput from '../input/DateInput';
import FormField, { BaseFormFieldProps } from './FormField';
import { css } from 'glamor';
import { DateFormatFormField } from '../../../store/utils';

interface DateInputFormFieldProps extends BaseFormFieldProps, DateInputProps {
  clearElement?: any;
  parse?: any;
  timePrecision?: any;
  timePickerProps?: any;
}

const centerLabelVerticallyClassName = css({
  '& .bp3-label': {
    alignSelf: 'center',
  },
});

const DateInputFormField = (props: DateInputFormFieldProps) => {
  const { clearElement, parse, maxDate, ...rest } = props;

  const isTimePickerShown = () => {
    const { timePrecision, timePickerProps } = props;
    return !!(timePrecision || timePickerProps);
  };

  const getParse = (value) => {
    const format = DateFormatFormField;
    const newValue =
      !isTimePickerShown() && value && moment(value, format, true).isValid()
        ? moment(value, format)
          .hour(0)
          .toDate()
        : value;

    const parseFn = parse || ((a) => a);

    return parseFn(newValue);
  };

  return (
    <FormField
      {...rest}
      allowNull={true}
      className={props.inline ? `${centerLabelVerticallyClassName}` : ''}
      parse={getParse}
    >
      {({ input }) => (
        <DateInput {...input} inputProps={input} clearElement={clearElement} maxDate={maxDate}/>
      )}
    </FormField>
  );
};

export default DateInputFormField;
